export default __webpack_public_path__ + "static/media/cutLength.58ccbd3c.jpg";